<label mat-dialog-title 
class="mat-dialog-header">
  <span class="title">Anulación de Notas de Venta</span><br />
  <span class="subtitle"
    ><b>Todos los items de despachos listados quedarán anulados</b></span
  >
</label>
<mat-dialog-content>
  <app-data-table
    type="massiveProductCancellation"
    [data]="dispatchItemList"
    size="large"
    id='massiveProductCancellation'
    (updateInline)="updateQuantityCancellation($event)"
    (changeSelect)="changeSelectReason($event)"
  >
  </app-data-table>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button
    mat-stroked-button
    mat-dialog-close
    id="cancelPartialCancellation"
    (click)="onClosePartialCancellation()"
    class="b-s m-2"
  >
    Cancelar
  </button>
  <button
    mat-flat-button
    (click)="onSubmitPartialCancellation()"
    id="submitPartialCancellation"
    style="background-color:#c92100;color:white;"
    class="button-primary-event border-box"
  >
    Anular Pedidos
  </button>
</mat-dialog-actions>

<button
  mat-button
  mat-dialog-close
  id="closePartialCancellation"
  (click)="onClosePartialCancellation()"
  class="dialog-close"
>
  <mat-icon>close</mat-icon>
</button>
